var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMenuRvparksWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3884 0.492188C18.1473 0.492188 18.875 0.791295 19.4107 1.33147L26.3036 8.22433C26.8393 8.76004 27.1429 9.48772 27.1429 10.2467V20.4922H30V23.3493H18.3929C17.7545 25.8136 15.5179 27.635 12.8571 27.635C10.1964 27.635 7.95536 25.8136 7.32143 23.3493H1.42857C0.638393 23.3493 0 22.7109 0 21.9208V3.34933C0 1.76897 1.27679 0.492188 2.85714 0.492188H17.3884ZM12.8571 19.0636C11.2768 19.0636 10 20.3404 10 21.9208C10 23.5011 11.2768 24.7779 12.8571 24.7779C14.4375 24.7779 15.7143 23.5011 15.7143 21.9208C15.7143 20.3404 14.4375 19.0636 12.8571 19.0636ZM17.3884 3.34933H2.85714V20.4922H7.32143C7.95536 18.0279 10.1964 16.2065 12.8571 16.2065C15.5179 16.2065 17.7589 18.0279 18.3929 20.4922H24.2857V10.2467L17.3884 3.34933ZM17.1429 6.20647V14.7779H5.71429V6.20647H17.1429ZM14.2857 9.06362H8.57143V11.9208H14.2857V9.06362Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMenuRvparksWhite);
export default __webpack_public_path__ + "static/media/new-menu-rvparks-white.f6f1e704fe3cee5a65a869e23556c109.svg";
export { ForwardRef as ReactComponent };